import React, { useState } from 'react';
import SignatureForm from './components/SignatureForm';
import SignaturePreview from './components/SignaturePreview';
import SignatureDownload from './components/SignatureDownload';
import { LT_LOGO_BASE64 } from './components/Logo';
import CopyToClipboardButton from './components/CopyToClipboardButton';

interface Section {
  displayName: string;
  addressLines: string[];
  phone: string;
  phone2?: string;
  fax?: string;
  email: string;
}

const sections: Record<string, Section> = {
  zentrale: {
    displayName: 'IT Solutions | Media Design | Legal Tech',
    addressLines: ['Negelerstraße 11', '72764 Reutlingen', '', 'Geschäftsführer: Philipp M. Nellißen', 'Registergericht Stuttgart, HRB 789975', 'St-Nr. 86115/29406', 'USt-ID DE361866205' ],
    phone: '+49 (0) 7121 1594190',
    email: 'illuminate@laterna.tech',
  }
};

const App: React.FC = () => {
  const [name, setName] = useState('');
  const [position, setPosition] = useState('');
  const [role1, setRole1] = useState('');
  const [role2, setRole2] = useState('');
  const [phonePrivate, setPhonePrivate] = useState('');
  const [sectionKey, setSectionKey] = useState('zentrale');
  const section = sections[sectionKey];

  // Authentication
  const PASSWORD = 'Zukunft';
  const [authenticated, setAuthenticated] = useState(false);
  const [passwordInput, setPasswordInput] = useState('');
  const handleLogin = () => {
    if (passwordInput === PASSWORD) {
      setAuthenticated(true);
    } else {
      alert('Falsches Passwort!');
      setPasswordInput('');
    }
  };

  if (!authenticated) {
    const onSubmit = (e: React.FormEvent) => {
      e.preventDefault();
      handleLogin();
    };

    return (
      <div className="container mt-5">
        <h2 className="text-center mb-4">Passwort benötigt</h2>
        <div className="d-flex justify-content-center">
          <div className="w-50">
            <form onSubmit={onSubmit}>
              <div className="mb-3">
                <label htmlFor="password" className="form-label">Passwort</label>
                <input type="password" id="password" className="form-control" value={passwordInput} onChange={(e) =>
                  setPasswordInput(e.target.value)}
                  placeholder="Geben Sie das Passwort ein"
                />
              </div>
              <button type="submit" className="btn btn-info w-100">
                Anmelden
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }


  const htmlContent = `<!DOCTYPE html>
<html lang="de">
<head><meta charset="UTF-8" /></head>
<body>
  <div style="font-family: Calibri, sans-serif; font-size: 12px;">
    <p>Mit freundlichen Grüßen<br/><br/>
      <b>${name || 'Ihr Name'}</b><br/>
      ${position || 'Ihre Funktion'}<br/><br/>
      ${role1 || 'Funktion bei Laterna.Tech'}<br/>
      ${role2 || ''}<br/><br/>
      <img src="data:image/png;base64,${LT_LOGO_BASE64}" style="width:250px;" />
    </p>
    <p style="color:#1c1c1c;">
      <b>Laterna.Tech</b><br/>
      <b>${section.displayName}</b><br/><br/>
      ${section.addressLines.join('<br/>')}<br/><br/>
      Telefon: <a href="tel:${section.phone.replace(/[^+\d]/g, '')}" style="color:#1c1c1c; text-decoration:none">${section.phone}</a><br/>
      ${section.phone2 ? `Telefon 2: <a href="tel:${section.phone2.replace(/[^+\d]/g, '')}" style="color:#1c1c1c; text-decoration:none">${section.phone2}</a><br/>` : ''}
      ${phonePrivate ? `Telefon (privat): <a href="tel:${phonePrivate.replace(/[^+\d]/g, '')}" style="color:#1c1c1c; text-decoration:none">${phonePrivate}</a><br/>` : ''}
      ${section.fax ? `Fax: <a href="tel:${section.fax.replace(/[^+\d]/g, '')}" style="color:#1c1c1c; text-decoration:none">${section.fax}</a><br/>` : ''}
      E-Mail: <a href="mailto:${section.email}" style="color:#1c1c1c; text-decoration:none">${section.email}</a><br/><br/>
      <a href="https://laterna.tech" target="_blank" style="color:#1c1c1c; text-decoration:none">https://laterna.tech</a><br/><br/>
    </p>
    <p style="font-family: Arial, sans-serif; font-size: 8px;">
      <b>Pflichtinformationen gemäß Artikel 13 DSGVO:</b><br/>
      Im Falle des Erstkontakts sind wir gemäß Art. 12, 13 DSGVO verpflichtet, Ihnen folgende datenschutzrechtliche Pflichtinformationen zur Verfügung zu stellen: Wenn Sie uns per E-Mail kontaktieren, verarbeiten wir Ihre personenbezogenen Daten nur, soweit an der Verarbeitung ein berechtigtes Interesse besteht (Art. 6 Abs. 1 lit. f DSGVO), Sie in die Datenverarbeitung eingewilligt haben (Art. 6 Abs. 1 lit. A DSGVO), die Verarbeitung für die Anbahnung, Begründung, inhaltliche Ausgestaltung oder Änderung eines Rechtsverhältnisses zwischen Ihnen und uns erforderlich sind (Art. 6 Abs. 1 lit. b DSGVO) oder eine sonstige Rechtsnorm die Verarbeitung gestattet. Ihre personenbezogenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z. B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen – insbesondere steuer- und handelsrechtliche Aufbewahrungsfristen – bleiben unberührt. Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Ihnen steht außerdem ein Recht auf Widerspruch, auf Datenübertragbarkeit und ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Ferner können Sie die Berichtigung, die Löschung und unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten verlangen. Details entnehmen Sie unserer Datenschutzerklärung: <a href="https://laterna.tech/datenschutz" target="_blank" style="color:#1c1c1c;">https://laterna.tech/datenschutz</a>.
    </p>
  </div>
</body>
</html>`;

  return (
    <div className="container mt-5 mb-5">
      <h1 className="text-center mb-4">Laterna.Tech E-Mail-Signatur Generator</h1>
      <div className="row">
        <div className="col-12 col-lg-6">
          <SignatureForm
            name={name}
            position={position}
            role1={role1}
            role2={role2}
            phonePrivate={phonePrivate}
            sectionKey={sectionKey}
            sections={sections}
            setName={setName}
            setPosition={setPosition}
            setRole1={setRole1}
            setRole2={setRole2}
            setPhonePrivate={setPhonePrivate}
            setSectionKey={setSectionKey}
          />
        </div>
        <div className="col-12 col-lg-6 mt-4 mt-lg-0">
          <SignaturePreview
            name={name}
            position={position}
            role1={role1}
            role2={role2}
            phonePrivate={phonePrivate}
            section={section}
          />
          <SignatureDownload htmlContent={htmlContent} />
          <CopyToClipboardButton text={htmlContent} />
        </div>
      </div>
    </div>
  );
};

export default App;
